import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { MapPin, ArrowRight } from "lucide-react";

export function AreaReminder() {
  const nav = useNavigate();
  const [missing, setMissing] = useState(null);
  useEffect(() => {
    api.get("/me/profile").then(({ data }) => {
      const m = [];
      if (!(data.work_areas || []).length) m.push("the areas you can work in");
      if (!(data.offered_services || []).length) m.push("the services you can offer");
      setMissing(m);
    }).catch(() => setMissing([]));
  }, []);
  if (!missing || missing.length === 0) return null;
  return (
    <div data-testid="area-reminder" className="flex flex-col gap-3 rounded-xl border border-brand/30 bg-brand-light/50 p-4 sm:flex-row sm:items-center">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand text-white"><MapPin size={18} /></span>
      <div className="flex-1">
        <p className="font-semibold text-ink">Tell us where you work and what you offer</p>
        <p className="text-sm text-ink-soft">Please choose {missing.join(" and ")} so the office can match you with the right clients.</p>
      </div>
      <button onClick={() => nav("/account")} data-testid="area-reminder-button"
        className="inline-flex items-center justify-center gap-2 rounded-lg bg-brand px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-brand-dark">
        Choose now <ArrowRight size={15} />
      </button>
    </div>
  );
}
